/** @jsx jsx */
import { Box, jsx } from 'theme-ui'

const YoutubeVideo = ({ aspectRatio = '16:9', id }) => {
  const embedUrl = `https://www.youtube.com/embed/${id}`

  let aspectRatioPadding = '56.25%'
  if (aspectRatio && aspectRatio.includes('1:1')) {
    aspectRatioPadding = '100%'
  }

  return (
    <Box
      sx={{
        height: 0,
        maxWidth: '100%',
        overflow: 'hidden',
        pb: aspectRatioPadding,
        position: 'relative',
      }}
    >
      <iframe
        width="560"
        height="315"
        src={embedUrl}
        frameBorder="0"
        title="Embedded YouTube video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        sx={{
          border: 0,
          height: '100%',
          left: 0,
          position: 'absolute',
          top: 0,
          width: '100%',
        }}
      ></iframe>
    </Box>
  )
}

export default YoutubeVideo
